class SFProductBundle extends HTMLElement{
    constructor(){
        super();
    }
    // connectedCallback(){
    //     this.carousalEl = this.querySelector('.swiper');
    //     this.paginationEl = this.querySelector('.swiper-pagination');
    //     this.comboProduct = this.querySelectorAll('.in-the-set-wrapper > div');
    //     this.querySelector('.in-the-set-wrapper').style.height = `${this.comboProduct[0].clientHeight + 50}px`;
    //     this.comboProduct.forEach(e=>e.style.position="absolute"); 
    //     this.sliderInit();
    // }
    sliderInit(){
        this.slider = new MinimogLibs.Swiper(this.carousalEl,{
            loop:false,
            // To set the width of each slide, use the 'slidesPerView' and 'spaceBetween' options.
            // For example, to show one slide per view and control width via CSS:
            slidesPerView: 1,
            navigation: {
                nextEl: 'sf-product-bundle .swiper-button-next',
                prevEl: 'sf-product-bundle .swiper-button-prev',
              },
            // If you want to set a fixed width in px for each slide, use 'slidesPerView: "auto"' and set width in CSS.
            pagination:{
                el:this.paginationEl,
                clickable:true,
            },
        })
    }
    observeComboProducts() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    this.comboSingleProduct.forEach(e=>{
                       if(e.id === entry.target.id){
                        e.classList.add('active');
                       } else{
                        e.classList.remove('active');
                       }
                    })
                }
            });
        }, {
            threshold: 0.5
        });

        this.comboProduct.forEach(product => {
            observer.observe(product);
        });
    }

    connectedCallback() {
        this.carousalEl = this.querySelector('.swiper');
        this.paginationEl = this.querySelector('.swiper-pagination');
        this.comboProduct = this.querySelectorAll('.swiper-slide');
        this.comboSingleProduct = this.querySelectorAll('.in-the-set-wrapper > div');
        this.querySelector('.in-the-set-wrapper').style.height = `${this.comboSingleProduct[0].clientHeight + 50}px`;
        this.comboSingleProduct.forEach(e=>e.style.position="absolute"); 
        this.sliderInit();
        this.querySelector('.swiper-wrapper').addEventListener('scroll',()=>console.log("hii"))
        this.observeComboProducts();
    }
}
customElements.define('sf-product-bundle',SFProductBundle);